module.exports = __webpack_public_path__ + "img/download.fe60f49d.svg";